export default __webpack_public_path__ + "static/media/hero.de60be73.jpg";